import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { LOAD_REFERRER_CUSTOM_FIELDS, CREATE_REFERRER_CUSTOM_FIELD_DEFINITION, MERGE_REFERRER_CUSTOM_FIELDS, UPDATE_REFERRER_CUSTOM_FIELDS_DATA, UPDATE_REFERRER_CUSTOM_FIELD_DEFINITION, TOGGLE_REFERRER_CUSTOM_FIELD_DEFINITION_VISIBILITY, DELETE_REFERRER_CUSTOM_FIELD_DEFINITION, ORDER_REFERRER_CUSTOM_FIELD_DEFINITION } from "@Broker/@Modules/clients/referrers/store/referrer-actions";
import CustomDataFieldsForm from "@Broker/@Modules/clients/board/client-profile/components/custom-fields/forms/custom-data-fields-form";
import CreateCustomFieldForm from "@Broker/@Modules/clients/board/client-profile/components/custom-fields/forms/create-custom-field-form";
import EditFieldsDefinitionsForm from "@Broker/@Modules/clients/board/client-profile/components/custom-fields/forms/edit-fields-definitions-form";
import ReferrerCustomFieldsLoader from "./referrer-loader/referrer-custom-fields-loader.vue";
import { isEmpty, sortBy } from "lodash";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerCustomField",
  components: {
    CustomDataFieldsForm,
    CreateCustomFieldForm,
    EditFieldsDefinitionsForm,
    ReferrerCustomFieldsLoader,
    CollapsibleCard
  },
  props: {
    referrer: {
      type: Object,
      default: () => ({})
    },
    referrerId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      creating: false,
      editing: false,
      currentEditingField: null,
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ReferrerStore", ["referrersCustomFieldsDefinitions", "referrerCustomFields"])), {}, {
    showCustomDataFieldsForm() {
      return !this.creating && !this.currentEditingField && !this.editing;
    },
    referrerCustom() {
      return this.referrerCustomFields(this.referrerId);
    },
    customFields() {
      if (isEmpty(this.customFieldsDefinitions)) return [];
      const referrerCustomFields = this.referrerCustomFields(this.referrerId);
      return sortBy(referrerCustomFields, [field => {
        var _this$definitionsById;
        return _parseInt((_this$definitionsById = this.definitionsById[field.id]) == null ? void 0 : _this$definitionsById.fieldOrder);
      }, field => {
        var _this$definitionsById2;
        return moment((_this$definitionsById2 = this.definitionsById[field.id]) == null ? void 0 : _this$definitionsById2.createdAt).unix();
      }]);
    },
    customFieldsDefinitions() {
      return this.referrersCustomFieldsDefinitions;
    },
    definitionsById() {
      var _this$customFieldsDef;
      return (_this$customFieldsDef = this.customFieldsDefinitions.byId) != null ? _this$customFieldsDef : {};
    }
  }),
  async mounted() {
    this.loading = true;
    await this.LOAD_REFERRER_CUSTOM_FIELDS();
    this.MERGE_REFERRER_CUSTOM_FIELDS({
      referrerId: this.referrerId
    });
    this.$nextTick(() => {
      if (isEmpty(this.definitionsById)) this.toggleEditing(true);
      this.loading = false;
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [LOAD_REFERRER_CUSTOM_FIELDS, CREATE_REFERRER_CUSTOM_FIELD_DEFINITION, MERGE_REFERRER_CUSTOM_FIELDS, UPDATE_REFERRER_CUSTOM_FIELDS_DATA, UPDATE_REFERRER_CUSTOM_FIELD_DEFINITION, DELETE_REFERRER_CUSTOM_FIELD_DEFINITION, TOGGLE_REFERRER_CUSTOM_FIELD_DEFINITION_VISIBILITY, ORDER_REFERRER_CUSTOM_FIELD_DEFINITION])), {}, {
    toggleCreating(creating) {
      this.creating = creating != null ? creating : !this.creating;
      if (this.creating) {
        this.toggleEditing(false);
        this.toggleEditField();
      }
    },
    toggleEditing(editing) {
      this.editing = editing != null ? editing : !this.editing;
      if (this.editing) {
        this.toggleCreating(false);
        this.toggleEditField();
      }
    },
    toggleEditField(id) {
      if (id) {
        var _context;
        const currentField = _findInstanceProperty(_context = this.customFields).call(_context, field => field.id === id);
        this.currentEditingField = _objectSpread(_objectSpread({}, this.definitionsById[id]), {}, {
          value: currentField.value
        });
      } else this.currentEditingField = null;
    },
    async handleFieldChange(value, action) {
      const {
        createCustomFieldForm
      } = this.$refs;
      const actionMap = {
        create: this.handleCreate,
        update: this.handleEdit
      };
      try {
        createCustomFieldForm.saving = true;
        await actionMap[action](value);
        this.MERGE_REFERRER_CUSTOM_FIELDS({
          referrerId: this.referrerId
        });
        createCustomFieldForm.savingStatus = true;
        this.$nextTick(() => {
          if (action === "update") this.toggleEditField(null);else this.creating = false;
        });
      } catch (e) {
        createCustomFieldForm.savingStatus = false;
      } finally {
        createCustomFieldForm.saving = false;
      }
    },
    handleCustomFieldDataChange(value) {
      this.UPDATE_REFERRER_CUSTOM_FIELDS_DATA({
        referrerId: this.referrerId,
        customFields: value
      });
      this.MERGE_REFERRER_CUSTOM_FIELDS({
        referrerId: this.referrerId
      });
      this.$emit("update:referrer", _objectSpread(_objectSpread({}, this.referrer), {}, {
        ["customFields"]: value
      }));
    },
    async handleCreate(customFieldDefinition) {
      await this.CREATE_REFERRER_CUSTOM_FIELD_DEFINITION({
        customFieldDefinition
      });
    },
    async handleDelete({
      id: customFieldDefinitionId,
      origin
    }) {
      if (origin === "definition") {
        await this.DELETE_REFERRER_CUSTOM_FIELD_DEFINITION({
          boardId: this.boardId,
          customFieldDefinitionId
        });
        this.MERGE_REFERRER_CUSTOM_FIELDS({
          referrerId: this.referrerId
        });
      } else if (origin === "orphan") {
        var _context2;
        this.handleCustomFieldDataChange(_filterInstanceProperty(_context2 = this.customFields).call(_context2, ({
          id
        }) => customFieldDefinitionId !== id));
      }
    },
    handleOrder(customFieldDefinitions) {
      this.ORDER_REFERRER_CUSTOM_FIELD_DEFINITION({
        customFieldDefinitions
      });
    },
    async handleEdit(value) {
      await this.UPDATE_REFERRER_CUSTOM_FIELD_DEFINITION({
        customFieldDefinition: value
      });
    },
    handleVisibilityToggle(customFieldDefinitionId) {
      this.TOGGLE_REFERRER_CUSTOM_FIELD_DEFINITION_VISIBILITY({
        customFieldDefinitionId
      });
      this.MERGE_REFERRER_CUSTOM_FIELDS({
        referrerId: this.referrerId
      });
    }
  })
});